import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shared-status-indicator',
  templateUrl: './shared-status-indicator.component.html',
  styleUrls: ['./shared-status-indicator.component.scss'],
})
export class SharedStatusIndicatorComponent {
  @Input() label: string = '';
  @Input() status_class: string | { [key: string]: boolean } = '';
}
